import * as React from 'react';

import cn from 'classnames';

export const ControlLabel: React.FC<React.HTMLProps<HTMLLabelElement>> = ({ className, ...props }) => (
  <label {...props} className={cn('control-label', className)} />
);
